// extracted by mini-css-extract-plugin
export var root = "L_wF";
export var wrapper = "L_wG";
export var image = "L_wH d_w d_y d_W";
export var imageWithHeight = "L_wJ";
export var crop = "L_wK";
export var round = "L_wL";
export var fixedHeight = "L_wM";